<template>
  <div class="DataTableFilteredOnApiComponent  DataTables">
    <p>{{lang.infotext_2}}:</p>
    
    <span id="advanced_search_panel" class="advanced-search-panel nodisplay">
      <p>{{lang.infotext_1}}:</p>
      <table class="advanced-search">
        <tr id="filter_col1" data-column="0">
            <td>{{ lang.label_Column }}:&nbsp;</td>
            <td align="center"><select class="column_filter form-control form-control-sm" id="col0_select"></select></td>
            <!-- <td>Condition:&nbsp;</td>
            <td align="center"><select class="column_filter form-control form-control-sm" id="col0_select2"></select></td> -->
            <td>{{ lang.label_Value }}:&nbsp;</td>
            <td align="center"><input type="text" class="column-filter-input column_filter form-control form-control-sm" id="col0_filter"></td>
        </tr>
        <tr id="filter_col2" data-column="1">
            <td>{{ lang.label_Column }}:&nbsp;</td>
            <td align="center"><select class="column_filter form-control form-control-sm" id="col1_select"></select></td>
            <td>{{ lang.label_Value }}:&nbsp;</td>
            <td align="center"><input type="text" class="column-filter-input column_filter form-control form-control-sm" id="col1_filter"></td>
        </tr>
        <tr id="filter_col3" data-column="2">
            <td>{{ lang.label_Column }}:&nbsp;</td>
            <td align="center"><select class="column_filter form-control form-control-sm" id="col2_select"></select></td>
            <td>{{ lang.label_Value }}:&nbsp;</td>
            <td align="center"><input type="text" class="column-filter-input column_filter form-control form-control-sm" id="col2_filter"></td>
        </tr>
      </table>
    </span>
    <div :id="id">
      <LoaderComponent  v-if="!isData"></LoaderComponent>
    </div>
    <ContextMenuComponent v-if="isPlugin" :menu="menuPlugin" :id="name" :lang="lang"></ContextMenuComponent>
    <ContextMenuComponent v-if="!isPlugin" :menu="menu" :id="name" :lang="lang"></ContextMenuComponent>
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '../../Tools/Tools';
import dt from 'datatables.net-bs4';




require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import { mapGetters } from 'vuex'
export default {
  name: 'DataTableFilteredOnApiComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,
    ContextMenuComponent

  },
  data () {
      return {
        name: "DataTableFilteredOnApiComponent",
        id: "tableplace_"+this._uid,
        columns: [],
        colsAssign: [],
        activeActionIds: [],
        contextMenu: {},
        dblclick: false,
        //list of items in the context menu:
        menu: [
          {id: "Details", text: this.lang.contextmenu_text_Details},
          {id: "Derive", text: this.lang.contextmenu_text_Derive},
          {id: "Withdraw", text: this.lang.contextmenu_text_Withdraw},
          //{id: "Delete", text: this.lang.contextmenu_text_Delete},
        ],
        menuPlugin: [
          { id: "Place", text: this.lang.contextmenu_text_Place },
          { id: "Details", text: this.lang.contextmenu_text_Details },
          { id: "Derive", text: this.lang.contextmenu_text_Derive },
          { id: "Withdraw", text: this.lang.contextmenu_text_Withdraw },
        ],
        visibility: ["NotExposed", "ExposedToTables", "TransferredToDesign", "ForceDisplayed", "ForceHidden"],
        lengthMenu: 20,
        
        clickedColumnIndex: null,
        mouseXInTable: null,
        
      }
  },
  computed: {
    ...mapGetters({
      appConf: 'appConf',
      isPlugin: "isPlugin",
      globalSettings: "globalSettings"

    }),
    currentUser(){
      return this.$store.getters.currentUser;
    },
    categoryId(){
      if (this.$store.getters.selectedTreeItemObject == undefined){
        return 1;
      }else{
        return this.$store.getters.selectedTreeItemObject.categoryId;
      }
    },
    selectedTreeItemObject(){

      return this.$store.getters.selectedTreeItemObject
    },
    activeActions(){

      return this.$store.getters.pm_activeActions
    },
    isData(){

      return false
    },
    
    reloadedAfterActionComplex() {
      
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {
    this.activeActionIds = [];
    
    for (let i = 0, lei = this.activeActions.length; i < lei; i++){
      
      const obj = {
        actionId: this.activeActions[i].actionId
      }
      this.activeActionIds.push(obj);
    }
    
  },
  watch: {
    categoryId: function(){
      
      this.getProperties();
    },
    activeActions: {
      handler: function(){

        this.activeActionIds = [];
        for (let i = 0, lei = this.activeActions.length; i < lei; i++){
          
          const obj = {
            actionId: this.activeActions[i].actionId
          }
          this.activeActionIds.push(obj);
        }
        

       
        this.getProperties();
      },
      deep: true
    },
    
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getProperties();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    

  },
  updated() {

  },
  mounted: function () {
    
    this.getProperties();


  },
  methods: {
    setSearchSelect() {
      let data = this.columns;
      // let col0_select2 = document.getElementById("col0_select2");
      // col0_select2.options.length = 0;
      // let optiona = document.createElement("option");
      // optiona.setAttribute("value", "");
      // let txa = document.createTextNode("Contains");
      // optiona.append(txa);
      // let optionb = document.createElement("option");
      // optionb.setAttribute("value", "");
      // let txb = document.createTextNode("Does not contain");
      // optionb.append(txb);
      // let optionc = document.createElement("option");
      // optionc.setAttribute("value", "");
      // let txc = document.createTextNode("Equals");
      // optionc.append(txc);
      // let optiond = document.createElement("option");
      // optiond.setAttribute("value", "");
      // let txd = document.createTextNode("Not");
      // optiond.append(txd);
      // col0_select2.appendChild(optiona);
      // col0_select2.appendChild(optionb);
      // col0_select2.appendChild(optionc);
      // col0_select2.appendChild(optiond);
      

  //console.log("setSearchSelect")


      let col0_select = document.getElementById("col0_select");
      col0_select.options.length = 0;
      let col1_select = document.getElementById("col1_select");
      col1_select.options.length = 0;
      let col2_select = document.getElementById("col2_select");
      col2_select.options.length = 0;

      let option0 = document.createElement("option");
      option0.setAttribute("value", "");
      let tx0 = document.createTextNode("");
      option0.append(tx0);
      col0_select.appendChild(option0);
      let option1 = document.createElement("option");
      option1.setAttribute("value", "");
      let tx1 = document.createTextNode("");
      option1.append(tx1);
      col1_select.appendChild(option1);
      let option2 = document.createElement("option");
      option2.setAttribute("value", "");
      let tx2 = document.createTextNode("");
      option2.append(tx2);
      col2_select.appendChild(option2);

      for (let i = 2, lei = data.length; i < lei; i++){
        // TODO: handle the internal columns later as well
        //       remove them for now to prevent confusion
        if(["Category","Revision","Creator","Date","Status"].indexOf(data[i].name) >=0){
          continue;
        }
        let option0 = document.createElement("option");
        option0.setAttribute("value", i);
        let tx0 = document.createTextNode(data[i].name);
        option0.append(tx0);
        col0_select.appendChild(option0);

        let option1 = document.createElement("option");
        option1.setAttribute("value", i);
        let tx1 = document.createTextNode(data[i].name);
        option1.append(tx1);
        col1_select.appendChild(option1);

        let option2 = document.createElement("option");
        option2.setAttribute("value", i);
        let tx2 = document.createTextNode(data[i].name);
        option2.append(tx2);
        col2_select.appendChild(option2);
      }
    },
    getProperties() {
      
      let reloadObj = {
        status: true,
        name: "Refresh"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      
      let vue = this;

      let categoryId = 1;
      if (this.selectedTreeItemObject.categoryId != undefined){
        categoryId = this.selectedTreeItemObject.categoryId;
      }

      const obj = {
        categoryId: categoryId,
        actions: this.activeActionIds
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProperties", obj)
      .then((result) => {

        //console.log(result)
        
        vue.buildColumns(result.data);

      })

    },
    

    buildColumns(properties){
      this.columns = [
          {
            name: "Id",
            alignInColumn: "left",
            propertyId: "",
            type: "text",
            property: "col___revisionId"
          },
          {
            name: this.lang.header_Image,
            alignInColumn: "left",
            propertyId: "",
            type: "image",
            property: "col___image"
          },
          {
            name: this.lang.header_Status,
            alignInColumn: "left",
            propertyId: "",
            type: "text",
            property: "col___status"
          },
          {
            name: this.lang.header_Revision,
            alignInColumn: "left",
            propertyId: "",
            type: "text",
            property: "col___revision"
          },
          {
            name: this.lang.header_Category,
            alignInColumn: "left",
            propertyId: "",
            type: "text",
            property: "col___category"
          },
          
        ];

      this.colsAssign = [
        { "data": "col___revisionId" },
        { "data": "col___image" },
        { "data": "col___status" },
        { "data": "col___revision" },
        { "data": "col___category" },
        

      ]

      let objLogin = {
        name: this.lang.header_PartLogin,
        alignInColumn: "left",
        propertyId: "",
        type: "text",
        property: "col___login"
      }
      let objDate = {
        name: this.lang.header_PartDate,
        alignInColumn: "left",
        propertyId: "",
        type: "text",
        property: "col___modificationDate"
      }

      let objLoginAssign = { "data": "col___login" }
      let objDateAssign = { "data": "col___modificationDate" }
      
      properties.sort(function(a, b){return a.priority-b.priority});

      for (let i = 0, lei = properties.length; i < lei; i++){

        if (this.selectedTreeItemObject.categoryId == 1){
          
          if (properties[i].origins == "own"){
            
            let obj = {
              name: properties[i].name,
              alignInColumn: "left",
              propertyId:properties[i].propertyId,
              type: properties[i].type,
              property: "col___"+properties[i].propertyId
            }
            this.columns.push(obj);

            
            let objAssign = {
              data: "col___"+properties[i].propertyId

            }

            this.colsAssign.push(objAssign)
          }else{
            
          }
          
        }else{
         
          let obj = {
            name: properties[i].name,
            alignInColumn: "left",
            propertyId:properties[i].propertyId,
            type: properties[i].type,
            property: "col___"+properties[i].propertyId
          }
          this.columns.push(obj);

          let objAssign = {
            data: "col___"+properties[i].propertyId

          }

          this.colsAssign.push(objAssign)
        }
        
      }

      this.columns.push(objLogin);
      this.columns.push(objDate);
      this.colsAssign.push(objLoginAssign)
      this.colsAssign.push(objDateAssign)

      this.setSearchSelect();
      this.buildTable();
    },
    
    buildTable(){
      

      //let lengthMenu = 20;

      //console.log('buildTable');
      
      if (this.$store.getters.outerData != true){
        
        this.$store.dispatch("deleteAllSelectedRows");
        this.$store.dispatch("setOuterData", false);
      }
      
      var tableplace = document.getElementById("tableplace_"+this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      var tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      

      var columnDefs = [];


      let _vue = this;

      var len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++){

        let el = {
          targets: i,
          className: '_dt-body-'+ _vue.columns[i].alignInColumn,
          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.value.display != undefined) {
              data.value.display = $.fn.dataTable.render.text().display(data.value.display);
            }

            if (meta.col == 0){
              if (data.name == "revisionId"){
                return  data.revisionId
              }

            }

            let toDisplay = "";
            if (data == undefined){
              
              data = {
                value: {
                  display: "<span style='color:red'>! " + meta.col + "-" + meta.row + "</span"
                }
              }
            }
            
            
            if (data.value != null){
              toDisplay = data.value.display;
            }

            if (meta.col == 1){
            
             
              if(y < _vue.lengthMenu){
                
                if (data.name == "image"){
                  let image = "";
                  if (data.assembly == true){
                    image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/assembly.svg\" class=\"image-category\">";
                  }else{

                    if (data.value.display == "default"){
                      image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/default.svg\" class=\"image-category\">";
                    }else  if (data.value.display == "electrical-part"){
                      image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/electrical-part.svg\" class=\"image-category\">";
                    }else  if (data.value.display == "mechanical-part"){
                      image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/mechanical-part.svg\" class=\"image-category\">";
                    }else  if (data.value.display == "software-part"){
                      image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/software-part.svg\" class=\"image-category\">";    
                    }else{
                      image = "<img id=\"image__"+data.revisionId+"\" src=\"\" class=\"image-category\">";

                                           

                      const obj = {
                        fileName: toDisplay
                      }
                      _vue.$store.dispatch("getImage", obj)
                      .then((result) => {
                        
                        if (result != null){
                          
                          let img = document.getElementById("image__"+data.revisionId);
                          
                          if (img != null){
                            //console.log(result)
                            img.src = URL.createObjectURL(result);

                            img.addEventListener('load', () => URL.revokeObjectURL(result), {once: true});
                          }
                          
                        }
                      
                      })
                    }
                    
                  }
                  


                  y++;
                  return image;
                }
                
              }

              

            }
            if (meta.col == 2){
              if (data.name == "status"){
                
                let status = "";
                let variant = Tools.getStatusColor(toDisplay);
                status += "<b-badge class='badge badge-"+variant+" '>"+toDisplay+" </b-badge>";
                if (data.used == true && _vue.appConf.status.isPRM){
                  status += "<b-badge class='badge badge-info '>"+_vue.lang.status_Used+" </b-badge>";
                }
                if (data.physical == false){

                  status += "<b-badge class='badge badge-diff '>"+_vue.lang.status_Alternative+" </b-badge>";
                }
                
                if (data.assembly == true){
                  status += "<b-badge class='badge badge-blue '>"+_vue.lang.status_Assembly+" </b-badge>";
                }
                return "<div class=\"badges\">"+status+"</div>";
              }
            }

            
             
            if (data.type == "part number"){

            }
            if (data.type == "link"){
              
              if (toDisplay != null) {
                let link = toDisplay;
                let pos = -1;
                if (_vue.globalSettings.displayHttpLinks == true) {
                  
                  pos = toDisplay.indexOf("http");

                  if (pos > -1) {
                    toDisplay = "<a href='" + link + "' target='_blank'>Link</a>";
                  }
                }
                if (_vue.globalSettings.displayLocalLinks == true) {
                  pos = toDisplay.indexOf("\\\\");
                  if (pos > -1) {
                    
                    link = toDisplay.split('\\').join('/');
                    
                    link = "file:///" + link
                    toDisplay = "<a href='" + link + "' target='_blank'>Local link</a>";
                  }
                  pos = link.indexOf("file://");
                  if (pos > -1) {

                    toDisplay = "<a href='" + link + "' target='_blank'>Local link</a>";
                  }
                } 
                
               
              }else{
                toDisplay = "";
              }

            }
            if (data.type == "image"){

              toDisplay = "<img height='20px' src='"+toDisplay+"'>"
            }

            

            return  toDisplay;
            

  
          }
        }



      columnDefs.push(el);




        var th1 = document.createElement("th");
        
        tr1.appendChild(th1);
        
        var br = document.createElement("br");
        var tx = document.createTextNode(this.columns[i].name);
        th1.appendChild(br);
        th1.appendChild(tx);
        //var input = document.createElement("input");
        //input.setAttribute("type", "text");
        //input.setAttribute("placeholder", "Search");
        //input.setAttribute("class", "form-control form-control-sm search-input-header");
        //th1.appendChild(input);

        
      }

        let vue = this;


      var option = {};


      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [[20, -1], [20, "All"]];
      option.order = [[ 5, "asc" ]];
      option.select = true;
      //option.searchDelay = 350;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;
      
      option.dom = '<fBlr<t>ip>';
      
      option.processing= true;
      option.serverSide= true;
      
      option.initComplete = function (settings, json) {
        
        // vue.mainTable.columns().eq(0).each(function(colIdx) {
        //   $('input', vue.mainTable.column(colIdx).header()).on('keyup change', function () {
        //     vue.mainTable
        //       .column(colIdx)
        //       .search(this.value)
        //       .draw();
        //   });
      
        //   $('input', vue.mainTable.column(colIdx).header()).on('click', function(e) {
        //       e.stopPropagation();
        //   });
        //});

        
      }
      option.fnDrawCallback = function( oSettings ) {
        
        vue.buildContextMenu();
      }
      option.buttons = [
        {
          text: vue.lang.infotext_1,
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
          action: function (e, dt, button, config) {
            
            let searchForm = document.querySelector('#advanced_search_panel');
            if (searchForm != null) {

              searchForm.classList.toggle("nodisplay");
            }
            
          }

        },
        {
          extend: 'copy',
          className: 'btn-' + vue.variant,
          exportOptions: {
              columns: ':visible'
          }
        },
        {
          extend: 'print',
          className: 'btn-' + vue.variant,
          messageTop: function () {
            return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeItemObject.category;
          },
          exportOptions: {
            columns: ':visible'
          },
          autoPrint: true,
          style: 'fullWidth',
          
          customize: function ( win ) {
              $(win.document.body)
                  .css( 'font-size', '10pt' )
                  

              $(win.document.body).find( 'table' )
                  .addClass( 'compact' )
                  .css( 'font-size', 'inherit' );
          }
        },
        {
          extend: 'csv',
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
        },
        {
          extend:'excel',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
            customize: function ( xlsx ){

            var sheet = xlsx.xl.worksheets['Parts.xml'];


        }},
        {
          extend: 'pdfHtml5',
          messageTop: function () {
                  return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeItemObject.category;
          },
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
          orientation: 'landscape',
          pageSize: 'A4',
          download: 'open',
          
          styles: {
            fullWidth: {
                fontSize: 3,
                bold: true,
                alignment: 'right',
                margin: [0,1900,0,80]		
            },
            subheader: {
                fontSize: 4
            },
            superMargin: {
                margin: [20, 0, 40, 0],
                fontSize: 5,
            }
          },
          customize: function ( doc ) {
            

            doc.pageMargins = [10,10,10,10];
            
            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();
            
            let numberOfHeaders = columnDefs.length;
            
            if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if(numberOfHeaders >= 18){
              
              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }
            
          },
          
        },
        {
        text: 'Json',
        exportOptions: {
          columns: ':visible'
        },
        className: 'btn-' + vue.variant,
            action: function ( e, dt, button, config ) {
                var data = dt.buttons.exportData();

                $.fn.dataTable.fileSave(
                    new Blob( [ JSON.stringify( data ) ] ),
                    'Parts.json'
                );
            }
        },
        {
          text: 'Reload',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
          action: function (e, dt, button, config) {

            vue.mainTable.ajax.reload();
          }

        },
        
        {
          extend: 'colvis',
          className: 'btn-' + vue.variant,
          
        },
        
        
      ];

      option.ajax = {
        url: /*this.server + */"/api/v3/partmanagement/parts/GetParts",

        crossDomain: true,
        type: 'POST',
        dataType: 'json',
        cors: true,
        contentType: 'application/json',
        secure: false,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
        },
        error: function (xhr, ajaxOptions, thrownError) {
          
          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON == undefined) {
            let error = JSON.parse(xhr.responseText);
            

            let obj = {
              text: vue.lang.alert_error_GetParts + " " + error.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
            return;
          }
          if (xhr.responseJSON.message == "Authorization failure."){
            
            vue.$store.dispatch("logout");
          }
          
        },
        data: function ( json ) {
          

          let categoryId = 1;

          if (vue.categoryId != undefined){

            categoryId = vue.categoryId;
          }

          json.categoryId = categoryId;

          let actions = vue.activeActionIds;

          json.actions = actions;

          

          for (let i = 0, lei = json.columns.length; i < lei; i++){
            json.columns[i].col = i;
          }

          
          //console.log(json)
            
            return JSON.stringify(json);
          //}

          
          
          
        },
        dataFilter: function(data){
          //todo 
          //vue.$store.dispatch("deleteAllSelectedRows");
          //console.log(data)
          
          y = 0;
          var json = JSON.parse(data);
            //console.log(json)
            if (json.data == null) {
              return
            }

            let newJson = {
              draw: json.data.draw,
              recordsFiltered: json.data.recordsFiltered,
              recordsTotal: json.data.recordsTotal,
              data: []
            }
            let rows = [];
            vue.lengthMenu = json.data.data.length;
            for (let i = 0, lei = json.data.data.length; i < lei; i++ ) {

              let row = {};
              let objId = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "revisionId",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                requestorUserId: json.data.data[i].requestorUserId,
                value: {
                  display: json.data.data[i].revisionId,
                  filter: json.data.data[i].revisionId,
                  sort: json.data.data[i].revisionId
                }
              };

              let revisionId = "col___revisionId";
              row[revisionId] = objId;
              
              let objImage = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "image",
                type: "image",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                used: json.data.data[i].used,
                assembly: json.data.data[i].assembly,
                physical: json.data.data[i].physical,
                value: {
                  assembly: json.data.data[i].assembly,
                  display: json.data.data[i].imagepath,
                  filter: json.data.data[i].imagepath,
                  sort: json.data.data[i].imagepath
                }
              };

              let image = "col___image";
              row[image] = objImage;
              
              let objStatus = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "status",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                used: json.data.data[i].used,
                assembly: json.data.data[i].assembly,
                physical: json.data.data[i].physical,
                value: {
                  display: json.data.data[i].status,
                  filter: json.data.data[i].status,
                  sort: json.data.data[i].status
                }
              };

              let status = "col___status";
              row[status] = objStatus;
              
              let objRevision = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "revision",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                value: {
                  display: json.data.data[i].revision,
                  filter: json.data.data[i].revision,
                  sort: json.data.data[i].revision
                }
              };

              let revision = "col___revision";
              row[revision] = objRevision;
              
              let a = json.data.data[i].category.split("\\");
              
              let b = a.splice(0, 1);
              
              let c = a.join('\\');
              

              let objCategory = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "category",
                type: "text",
                value: {
                  display: c,
                  filter: c,
                  sort: c
                }
              };

              let category = "col___category";
              row[category] = objCategory;
              
              let objLogin = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "login",
                type: "text",
                value: {
                  display: json.data.data[i].login,
                  filter: json.data.data[i].login,
                  sort: json.data.data[i].login
                }
              };

              let login = "col___login";
              row[login] = objLogin;
              
              let objDate = {
                partId: json.data.data[i].partId,
                revisionId: json.data.data[i].revisionId,
                name: "modificationDate",
                type: "text",
                value: {
                  display: Tools.longDateToShort(json.data.data[i].modificationDate, true),
                  filter: Tools.longDateToShort(json.data.data[i].modificationDate, true),
                  sort: Tools.longDateToShort(json.data.data[i].modificationDate, true)
                }
              };

              let partDate = "col___modificationDate";
              row[partDate] = objDate;
              
              for (let j = 0, lej = json.data.data[i].properties.length; j < lej; j++ ) {

                let obj = {
                  propertyId: json.data.data[i].properties[j].propertyId,
                  name: json.data.data[i].properties[j].name,
                  value: {
                    display: json.data.data[i].properties[j].value_display,
                    filter: json.data.data[i].properties[j].value_filter,
                    sort: json.data.data[i].properties[j].value_sort
                  },
                  type: json.data.data[i].properties[j].type,
                  visibility: json.data.data[i].properties[j].cisDesignation
                  
                }

                let key = "col___"+json.data.data[i].properties[j].propertyId;
                row[key] = obj;
                

              }

              rows.push(row);
            }


            newJson.data = rows;

            

            return JSON.stringify(newJson);
          },

        }



          if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
              this.mainTable.destroy();

          }

          this.mainTable = $('#place'+this._uid).DataTable(option);
          
      this.mainTable.column(0).visible(false);

          let _mainTable = this.mainTable;

          let el = document.getElementsByClassName("dataTables_processing")[0]
          
          if(this.isPlugin){
            el.classList.add("processing-top-plugin");
          }else{
            el.classList.add("processing-top");
          }
          

      //search input change view
      let searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      
      let searchplaceGlobal = document.getElementById("place"+this._uid+"_filter")
      
      let advencedSearch = document.createElement("div");
      advencedSearch.setAttribute("class", "advencedSearch");
      advencedSearch.setAttribute("id", "advencedSearch");

      let row1 = document.createElement("div");
      advencedSearch.appendChild(row1);
      let row2 = document.createElement("div");
      advencedSearch.appendChild(row2);
      let row3 = document.createElement("div");
      advencedSearch.appendChild(row3);

      let debounceTimeout = null;
      
      function filterColumn(table,ev) {
        //console.log('filterColumn');
        //console.log(ev);
        clearTimeout(debounceTimeout);
        for (let i = 0, lei = vue.columns.length; i < lei; i++){
          if (table.column(i).search() != "") {
            
            table.column(i).search("")
          }
          //table.column(i).search("").draw();
        }
        let filter0 = document.querySelector('#col0_filter');
        let select0 = document.querySelector('#col0_select');

        let filter1 = document.querySelector('#col1_filter');
        let select1 = document.querySelector('#col1_select');

        let filter2 = document.querySelector('#col2_filter');
        let select2 = document.querySelector('#col2_select');
        let actualFilterChange = false;
        let relatedPairs = [
          [select0,filter0],
          [select1,filter1],
          [select2,filter2]
        ];
        relatedPairs.forEach(pair => {
          
          if(ev.target === pair[0]){

            if(pair[0].value == ""){
              if(pair[1].value !== ""){
                pair[1].value = "";
                actualFilterChange = true;
                
              }
            } else {
              if(pair[1].value !== ""){
                actualFilterChange = true;
                table.column(pair[0].value).search(pair[1].value)
              }
              
            }
          } else if(ev.target === pair[1]){

            if(pair[0].value !== ""){
              if(pair[1].value !== pair[1].myLastVal){
                pair[1].myLastVal = pair[1].value;
                actualFilterChange = true;
                table.column(pair[0].value).search(pair[1].value)
              }
            } 

          } else if (pair[0].value !== "" && pair[1].value !== "") {
            table.column(pair[0].value).search(pair[1].value)
          }
        });
        if(actualFilterChange){
          debounceTimeout = setTimeout(table.draw,250);
        }
      }

      //console.log('adding search events');
      document.querySelectorAll(['input.column_filter', 'select.column_filter']).forEach((el) => {
        if(!el.myEventAdded){
          //console.log('adding event');

          el.addEventListener(el.type === 'text' ? 'keyup' : 'change', (ev) =>
            
            filterColumn(vue.mainTable,ev)
          );
          el.myEventAdded = true;
        }
      });
     

      $('#place'+vue._uid + ' thead').on('click', 'th', function(event) {
        vue.clickedColumnIndex = $(this).index();
        
        let tableLeft = $('#place'+vue._uid).offset().left;
        vue.mouseXInTable = event.pageX - tableLeft;
        
        
      });

      vue.mainTable.on('draw', function () {
        //console.log('om draw');
        if (vue.clickedColumnIndex !== null) {
          
          let th = $('#place' + vue._uid + ' thead th').eq(vue.clickedColumnIndex);
          let colLeft = th.offset().left - $('#place' + vue._uid).offset().left;
          
          let scrollContainer = $('#action_content_parts');
          let currentScroll = scrollContainer.scrollLeft();
          
          let newScroll = currentScroll + colLeft - vue.mouseXInTable;
          
          if (vue.colsAssign.length - 1 - vue.clickedColumnIndex < 6) {
            
            newScroll = 10000
            scrollContainer.scrollLeft(newScroll);
          
          } else {
            scrollContainer.scrollLeft(newScroll + 20);
          }
          
          vue.clickedColumnIndex =null;
        }
      });

      searchplaceGlobal.appendChild(advencedSearch);

          searchplace.firstChild.setAttribute("placeholder", "Enter search words")
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm" + " place" + this._uid);
          searchplace.firstChild.addEventListener("input", function(evt){

            _vue.$store.dispatch("setFilteredData", evt.target.value);

          })
          var stepWait = 0;
          var waitInterval;
            
          
          $(".dataTables_filter ." + "place" + this._uid)
          .unbind()           
          .bind('input', function (e) { 
            var item = $(this);
            stepWait = 0;
           
            if (!waitInterval) {
              waitInterval = setInterval(function () {
              
              if (stepWait >= 3) {
                clearInterval(waitInterval);
                waitInterval = '';
                let searchString = $(item).val();
                _mainTable.search(searchString).draw();
                stepWait = 0;
              }
              stepWait++;
            }, 150);
            } 

          });
          
          let lengthplace = document.getElementById("place"+this._uid+"_length");
          
          if (lengthplace.firstChild.firstChild != null){
            lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
          }

          
          this.mainTable
          .on( 'select', function ( e, dt, type, indexes ) {
              //var rowData = _mainTable.rows( indexes ).data().toArray();
              //var rowData = _mainTable.rows( indexes ).data();
              let rowData = _mainTable.rows('.selected').data();
              
              var count = _mainTable.rows( { selected: true } ).count();
              
              if (_vue.$store.getters.selectedRows.length ==  count - 1 ){
                
              }else{
                
                _vue.$store.dispatch("deleteAllSelectedRows");
              }
              
              _vue.$store.dispatch("setSelectedRows", rowData);
              
              

          })
          .on('deselect', function (e, dt, type, indexes) {
            
            if (_vue.dblclick == true) {
                
              function reset() {
                
                for (var i = 0, len = indexes.length; i < len; i++) {
                  var rowData = _mainTable.rows(indexes[i]).data();


                  _vue.$store.dispatch("deleteSelectedRows", rowData[0]);


                }
                _vue.dblclick = false;
                
              }
              setTimeout(reset, 2000)
            } else {
              for (var i = 0, len = indexes.length; i < len; i++) {
                var rowData = _mainTable.rows(indexes[i]).data();


                _vue.$store.dispatch("deleteSelectedRows", rowData[0]);


              }
            }
            
          });
          
          $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e) {
            _vue.dblclick = true;
            e.stopPropagation() 
            var data = _mainTable.row( this ).data();
            
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", [data]);

            if (_vue.isPlugin) {
              
              if (_vue.globalSettings.placingPrototype) {
                
                function place() {

                  _vue.$parent.$parent.$parent.$parent.$parent.$parent.placePart();
                }
                setTimeout(place, 2000)
              } else {
                
                if (data.col___status.value.display == "active") {
                  function place() {
                    
                    _vue.$parent.$parent.$parent.$parent.$parent.$parent.placePart();
                  }
                  setTimeout(place, 2000)
                 
                } else {
                  
                  let obj = {
                    text: _vue.lang.alert_placing,
                    time: 10,
                    type: "warning"
                  }
                  _vue.$store.dispatch("displayFooterAlert", obj);
                }
              }
            }else{
              
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.details();
            }
            
          } );

          

      },
      buildContextMenu(){
        

        var _vue = this;

        
        //context-menu
        var tableid = $("#place" + this._uid);

        $("#place" + this._uid + " tbody tr")
        .on("contextmenu", function(e) {
          
          let tr = $(this).closest('tr');
          let row = _vue.mainTable.row( tr );

          let data = row.data();

          _vue.contextMenu.row = data

          

          //methods in table component
          //var updateUser = _vue.updateUser;
          //var deleteUser = _vue.deleteUser;

          _vue.contextMenu.funcAction = function(_vue, action){

            //calling component methods depending on the context menu item clicked
            
            if (action == "Place"){
              _vue.$store.dispatch("deleteAllSelectedRows");
              _vue.$store.dispatch("setSelectedRows", [data]);
              if (_vue.globalSettings.placingPrototype) {

                function place() {

                  _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.placePart();
                }
                setTimeout(place, 2000)
              } else {

                if (data.col___status.value.display == "active") {
                  function place() {

                    _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.placePart();
                  }
                  setTimeout(place, 2000)

                } else {

                  let obj = {
                    text: _vue.lang.alert_placing,
                    time: 10,
                    type: "warning"
                  }
                  _vue.$store.dispatch("displayFooterAlert", obj);
                }
              }
            }
            if (action == "Details"){
              _vue.$store.dispatch("deleteAllSelectedRows");
              _vue.$store.dispatch("setSelectedRows", [data]);
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.details();
            }
            if (action == "Derive"){
              _vue.$store.dispatch("deleteAllSelectedRows");
              _vue.$store.dispatch("setSelectedRows", [data]);
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.derive();
            }
            if (action == "Withdraw"){
              _vue.$store.dispatch("deleteAllSelectedRows");
              _vue.$store.dispatch("setSelectedRows", [data]);
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.withdraw();
            }
            
            if (action == "Delete" && _vue.$store.getters.currentUser.role == "Admin"){
              _vue.$store.dispatch("deleteAllSelectedRows");
              _vue.$store.dispatch("setSelectedRows", [data]);
              //_vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent._delete();
            }  

            return true;
          }

          var height = tableid.height();

          var offsetX = tableid.offset().left;
          var offsetY = tableid.offset().top;

          var top = e.clientY - offsetY + 170;
          var left = e.clientX - offsetX + 10;

          
          $("#context-menu-"+_vue.name).css({
            display: "block",
            top: top,
            left: left
          });
          return false; //blocks default Webbrowser right click menu
        })
        .on("click", function() {
          
          $("context-menu-"+_vue.name).hide();
        });

        $("#context-menu-"+_vue.name + " a").on("click", function() {
          
          $(this)
            .parent()
            .hide();
        });
        document.addEventListener('click', function(e){
          let clickInside = e.target.closest("#context-menu-"+_vue.name);
          
          if(clickInside == null){
            
            let contextMenu = document.getElementById("context-menu-"+_vue.name);
            if (contextMenu != null){
              contextMenu.setAttribute('style', 'display:none');
            }
                                
          }
        });
        //context-menu
      }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .DataTableFilteredOnApiComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      white-space:nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 80px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }
    .processing-top{
      top: 50px;
    }
    .processing-top-plugin{
      //top: 120px;
    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 450px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image-category{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      
    }
    .badge{
      margin-right: 1px;
      
      margin-bottom: 2px;
    }
    .badges{
      margin-top: 3px;
      margin-bottom: 2px;
    }
    .image-svg{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-right: 3px;
      margin-bottom: 3px;
      background-color: white;
      padding: 2px;
    }
    .search-input-header{
      margin-top: 5px;
    }
    .advanced-search-panel{
      display: block;
      margin-bottom: 15px;
      border: solid 1px #999;
      padding: 10px;
       border-radius: 5px;
    }
    .advanced-search tr{
      
      height: 28px;

    }
    
    .nodisplay{
      display: none;
    }
    .column-filter-input{
      width: 200px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DataTableFilteredOnApiComponent.vue